import Navbar from "react-bootstrap/Navbar";
import Image from "react-bootstrap/Image";
import React, { useEffect, useRef } from "react";
import Container from "react-bootstrap/Container";
import logo from "../logo.png";
import "./Header.css";
import { Link } from "react-router-dom";

const Header = props => {
  let lastScrollY = 0;
  let ticking = false;
  const nav = useRef();
  const handleScroll = () => {
    lastScrollY = window.scrollY;

    if (!ticking) {
      window.requestAnimationFrame(() => {
        nav.current.style.height = `${250 - lastScrollY * 0.7}px`;
        ticking = false;
      });

      ticking = true;
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, true);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });

  return (
    <Navbar ref={nav}>
      <Container>
        <Link to="/">
          <Image src={logo} alt="Kapoff Produktion" />
        </Link>

        <section className="info">
          {props.children ? props.children : <p>Inget här!</p>}
        </section>
      </Container>
    </Navbar>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.jsx